import axios from 'axios';


//const API_URL = 'http://localhost:8080' + '/api';
const API_URL = 'https://xn----8sbarcofaremc5efde2e0e.xn--p1ai' + '/api';

class BaseService {
    // loginUser(user) {
    //     return axios
    //         .post(API_URL + 'log-in', {
    //             login: user.login,
    //             password: user.password
    //         })
    //         .then(response => {
    //             const { accessToken, refreshToken } = response.data;
    //             if (accessToken) {
    //                 localStorage.setItem('user', JSON.stringify(response.data));
    //             }
    //             return { accessToken, refreshToken };
    //         });
    // }
    sendNewAppeal(appeal) {
        return axios
            .post(API_URL + '/appeal', {
                name: appeal.name,
                email: appeal.email,
                comment: appeal.comment,
            })
            .then(response => {
                return { response };
            });
    }
    sendNewReport(report) {
        return axios
            .post(API_URL + '/report', {
                name: report.name,
                comment: report.comment,
                date: report.date
            })
            .then(response => {
                return { response };
            });
    }

    getAllReports(){
        return axios
            .get(API_URL + '/report')
            .then(response => {
                return  response ;
            });
    }
    // logout() {
    //     localStorage.clear()
    //     localStorage.setItem('lang', "ru")
    // }
}

export default new BaseService();